import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';

const { app } = PULSE;
const { MIS_TOKEN_HEADER_PROP, API_RETRY_COUNT } = app.common.CONSTANTS;

// RTK Query update: Create a baseQuery instance with headers
// RTK Query update: There should be one baseQuery instance for each API
const baseQuery = fetchBaseQuery({
    baseUrl: app.environment.cfsApi,
    prepareHeaders: (headers, { getState }) => {
        const token = getState().token;
        if (token) {
            headers.set(MIS_TOKEN_HEADER_PROP, token);
            return headers;
        }
        throw new Error('Token not available, cancelling request');
    }
});

// RTK Query update: Define an api service with a base URL and retry attempts
// RTK Query update: Endpoints can be added here or injected in components
export const cfsApi = createApi({
    reducerPath: 'cfsAPI',
    baseQuery: retry(baseQuery, { maxRetries: API_RETRY_COUNT }),
    endpoints: (build) => ({
        getMatchItem: build.query({
            query: (id) => `/matchItem/${id}`,
            transformResponse: modelMatchResponse
        }),
        getInterchange: build.query({
            query: (id) => `/matchInterchange/${id}`
        })
    })
});

/**
 * Take in a response from the getMatchItem api call and model the match data
 * by sorting the matchClock and scores so they're ready to work with.
 *
 * @param {object} response - Response from the getMatchItem api call
 * @returns {object} - Response contained a modelled match with sorted data
 */
function modelMatchResponse(response) {
    // Sort the clock into the right order by periodNumber
    if (response.score?.matchClock?.periods?.length) {
        response.score.matchClock.periods.sort(
            (a, b) => b.periodNumber - a.periodNumber
        );
    }

    // Sort score data into the right order by periodNumber
    if (response.score?.homeTeamScore?.periodScore?.length) {
        response.score.homeTeamScore.periodScore.sort((a, b) => {
            return a.periodNumber - b.periodNumber;
        });
    }

    if (response.score?.awayTeamScore?.periodScore?.length) {
        response.score.awayTeamScore.periodScore.sort((a, b) => {
            return a.periodNumber - b.periodNumber;
        });
    }

    return response;
}

export const { useGetMatchItemQuery, useGetInterchangeQuery } = cfsApi;
